exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banners-container {\r\n    width: 100%;\r\n    margin: 0px 0px 0px;\r\n    padding: 20px 0px 0px 0px;\r\n    background: #f5f5f5;\r\n}\r\n\r\n.banners-container .banner-wrapper {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/most-played/most-played.component.css
// module id = ../../../../../src/app/Modules/Shared/components/most-played/most-played.component.css
// module chunks = main